var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"calc(100% + 120px"}},[_c('SummaryBarChart',{key:"comission",attrs:{"data":_vm.data,"title":"commission","label":"commission"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }